import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OriginReferenceService extends BaseReferenceService {
  constructor() {
    super('OriginReference');
  }
}
